import { useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";


const FETCH_ALL_EXCHANGE_RATES = async () => {
  const response = await api.get(API_ROUTES.GET_EXCHANGE_RATES);
  return response.data.data;
};

export const getAllExchangeRates = (businessId) => {
  return useQuery({
    queryKey: ["exchangeRates", businessId],
    queryFn: () => FETCH_ALL_EXCHANGE_RATES(),
    enabled: !!businessId,
  });
};

const FETCH_RATE = async (payload) => {
  const response = await api.post(API_ROUTES.GET_RATE, payload);
  return response.data.data.rate;
};

export const getSingleRate = (data, businessId) => {
  return useQuery({
    queryKey: ["getRate", data],
    queryFn: () => FETCH_RATE(data),
    enabled: !!businessId,
  });
};
